import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-12 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6 md:order-2">
          <p className="text-sm text-gray-500">地址：清华大学能科楼C座</p>
          <p className="text-sm text-gray-500">邮编：100084</p>
          <p className="text-sm text-gray-500">电话：010-62772756</p>
        </div>
        <div className="mt-8 md:order-1 md:mt-0">
          <p className="text-center text-xs leading-5 text-gray-500">
            &copy; {new Date().getFullYear()} 清华大学陈文颖课题组
          </p>
        </div>
      </div>
    </footer>
  );
}